// extracted by mini-css-extract-plugin
export default {"wrapper":"C_CapsuleUserAvatars_wrapper__E5RPd"};